// extracted by mini-css-extract-plugin
export default {"container":"ZoTdp0MP","_fullscreen":"gBkQKaEc","mobile":"mobile","_error":"YZhqqNx8"};